import { LocationConfidenceScoresRecord } from "./models/locationConfidenceScoresRecord";
import AccuracyEvidenceRow from "./AccuracyEvidenceRow";
import { JSX } from "react";

interface AccuracyEvidenceLocationConfidenceScoresEntityProps {
  locationConfidenceScore: LocationConfidenceScoresRecord;
}

export default function AccuracyEvidenceLocationConfidenceScoresTab(evidence: AccuracyEvidenceLocationConfidenceScoresEntityProps): JSX.Element {
  return (
    <>
      <li className="list-group-item bordered" data-toggle="collapse" data-target={`#lcs-${evidence.locationConfidenceScore.NPI}`}>
        <div className="col-12">
          <span className="expandable">{evidence.locationConfidenceScore.Name}</span>
        </div>
      </li>
      <div className="collapse" id={`lcs-${evidence.locationConfidenceScore.NPI}`}>
        <AccuracyEvidenceRow keyName="npi" value="National Provider Identification Number" status={evidence.locationConfidenceScore.NPI} reference={`NPPES (${evidence.locationConfidenceScore.NppesCreatedDate})`} rowDepth="2" />
        <li className="list-group-item bordered evidence-depth-2" data-toggle="collapse" data-target="#locations">
          <div className="col-12">
            <span className="expandable">Locations</span>
          </div>
        </li>
        <div className="collapse" id="locations">
          {
            evidence.locationConfidenceScore.LocationConfidenceScores.map((lcs, i) =>
              <>
                <li className="list-group-item bordered" data-toggle="collapse" data-target={`#lcs-${evidence.locationConfidenceScore.NPI}-${i}`} key={`lcs-${i}`}>
                  <div className="col-12 evidence-depth-3">
                    <span className="expandable">{lcs.Address1}, {lcs.State}, {lcs.Zip} </span>
                  </div>
                </li>
                <div className="collapse" id={`lcs-${evidence.locationConfidenceScore.NPI}-${i}`}>
                  <AccuracyEvidenceRow keyName="prediction-value" value="Prediction Value" status={lcs.PredictionValue} reference={`Quest machine Learning (${lcs.CreatedDate})`} rowDepth="4" />
                  <AccuracyEvidenceRow keyName="prediction" value="Prediction" status={lcs.Prediction.toString()} reference={`Quest machine Learning (${lcs.CreatedDate})`} rowDepth="4" />
                  <AccuracyEvidenceRow keyName="confidence-score" value="Confidence Score" status={lcs.ConfidenceScore} reference={`Quest machine Learning (${lcs.CreatedDate})`} rowDepth="4" />
                  <AccuracyEvidenceRow keyName="rule" value="Rule" status={lcs.Rule} reference={`Quest machine Learning (${lcs.CreatedDate})`} rowDepth="4" />
                </div>
              </>
            )
          }
        </div>
      </div>
    </>
  );
}